import { render, staticRenderFns } from "./LKRoadmapsFeedTreeChildren.vue?vue&type=template&id=a3b831e4&"
import script from "./LKRoadmapsFeedTreeChildren.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedTreeChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports